import { store } from '@utils/configStore'
import { settingManagementReducer } from './slices'

export const injectSettingManagementStore = () => store.injectReducer('settingManagement', settingManagementReducer)
